import { Suspense } from 'react';

import type { XingletLoaderProps } from '@xing-com/crate-xinglet';
import {
  InternalXingletLoader,
  useRuntimeConfig,
} from '@xing-com/crate-xinglet/internal';

import { XingletErrorBoundary } from './xinglet-error-boundary';

export const RuntimeXingletLoader: React.FC<XingletLoaderProps> = ({
  error: errorFallback,
  fallback,
  name,
  ...rest
}) => {
  const { useStreaming = false } = useRuntimeConfig();

  if (!useStreaming) {
    return (
      <XingletErrorBoundary fallback={errorFallback} xinglet={name}>
        <InternalXingletLoader {...rest} fallback={fallback} name={name} />
      </XingletErrorBoundary>
    );
  }

  return (
    <XingletErrorBoundary fallback={errorFallback} xinglet={name}>
      <Suspense fallback={fallback}>
        <InternalXingletLoader {...rest} fallback={fallback} name={name} />
      </Suspense>
    </XingletErrorBoundary>
  );
};
